import { render, staticRenderFns } from "./FootLogo.vue?vue&type=template&id=a7fe9b5c"
var script = {}
import style0 from "./FootLogo.vue?vue&type=style&index=0&id=a7fe9b5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports